<template>
  <el-popover placement="right" width="250" trigger="hover">
    <div class="program-popover">
      <vue-qr
            backgroundColor="#fff"
            :margin="10"
            :text="chatParams.link"
            :size="150"
            :dotScale="1"
          ></vue-qr>
          <p>{{chatParams.text}}</p>
    </div>
    <el-button
      slot="reference"
      icon="el-icon-chat-dot-round"
      :size="size"
      :type="type"
      :plain="plain"
    >{{chatParams.btnText}}</el-button>
  </el-popover>
</template>

<script>
import { base_url, choose_url } from "@/datas/program.js";

import VueQr from "vue-qr";

// 聊一聊
export default {
  name: "chat-qrcode",
  components: {
    VueQr,
  },
  props: {
    chatConfig: {
      type: Object,
    },
    type: {
      type: String,
      default: "",
    },
    plain: {
      type: Boolean,
      default: false,
    },
    size:{
      type:String,
      default:'mini'
    }
  },
  computed: {
    chatParams() {
      const { defaultParams, chatConfig, erp_detail_url, jobfair_erp_detail_url } = this;

      let option = Object.assign({}, defaultParams, chatConfig);

      // 公司主页
      const {
        video_jobfair_id, company_id, video_erp_register_id, publish_id
      } = option

      let page
      if (video_jobfair_id){
        page = jobfair_erp_detail_url + `video_jobfair_id=${video_jobfair_id}&company_id=${company_id}&video_erp_register_id=${video_erp_register_id}&publish_id=${publish_id}`
      } else {
        page = erp_detail_url + `company_id=${company_id}`
      }

      // 登录之后再跳转页面
      option.link = base_url + encodeURIComponent(choose_url + encodeURIComponent(page));

      return option;
    },
  },
  data() {
    return {
      defaultParams: {
        video_erp_register_id: 0,
        video_jobfair_id: 0,
        company_id: 0,
        publish_id: 0,
        text: "打开【微信】-【扫一扫】来跟我聊聊吧",
        btnText: "聊聊",
      },
      jobfair_erp_detail_url: "/pages/jobfair/jobfair/erpDetail/main?",
      erp_detail_url: "/pages/seeker/company/detail/main?",
    };
  },
};
</script>
<style lang="scss">
.program-popover{
  display: flex;
  align-content: center;
  flex-direction: column;
  p{
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Chat/ChatQrcode.vue